<template>
  <div>
    <v-checkbox
      v-model="value.is_max_area"
      :label="`Уведомлять пользователя о превышении максимальной прощади при заказе территории`"
      dense
    ></v-checkbox>

    <v-checkbox
      v-model="value.is_max_request_area"
      :label="`Уведомлять пользователя если превышен лимит площади по запросам за сутки`"
      dense
    ></v-checkbox>

    <v-checkbox
      v-model="value.is_max_point_request_count"
      :label="`Уведомлять пользователя если превышено количество запросов по точке за сутки`"
      dense
    ></v-checkbox>

    <v-checkbox
      v-model="value.is_max_preset_request_count"
      :label="`Уведомлять пользователя если превышено количество запросов по территориям за сутки`"
      dense
    ></v-checkbox>
  </div>
</template>

<script>
import Notification from "../models/notification";

export default {
  name: "wapi-contract-notifications",
  props: {
    value: {
      type: Object,
      default: function() {
        return new Notification();
      }
    }
  }
};
</script>